/*
 * action types
 */

export const REPLACE_BRANCHES = "REPLACE_BRANCHES";
export const CLEAR_BRANCHES = "CLEAR_BRANCHES";
export const REPLACE_ALL_BRANCHES = "REPLACE_ALL_BRANCHES";

export const REPLACE_ALL = "REPLACE_ALL_BRANCHES";
export const CLEAR = "CLEAR_BRANCHES";
export const SET_PAGESIZE = "SET_BRANCHES_PAGESIZE";
export const SET_PAGENUMBER = "SET_BRANCHES_PAGENUMBER";
export const SET_BRANCHES_TEXTFILTER = "SET_BRANCHES_TEXTFILTER";
export const DELETE = "DELETE_BRANCHES";

/*
 * action creators
 */

export const Replace = (values, display) => ({ 
    type: REPLACE_BRANCHES,
    branches: values,
    branchesForDisplay: display
});

export const Clear = () => ({
    type: CLEAR_BRANCHES
});

export const ReplaceAllBranches = (values, totalResults, totalPage) => ({ 
    type: REPLACE_ALL_BRANCHES,
    branches: values,
    totalResults,
    totalPage
});

export const ReplaceAll = (values, display) => ({ 
    type: REPLACE_ALL,
    branches: values,
    branchesForDisplay: display
});

export const SetPageSize = (pageSize) => ({
    type: SET_PAGESIZE,
    pageSize
})

export const SetPageNumber = (pageNumber) => ({
    type: SET_PAGENUMBER,
    pageNumber
})

export const SetFilters = (filters) => ({
    type: SET_BRANCHES_TEXTFILTER,
    filters
})

export const Delete = (branch) => ({
    type: DELETE,
    branch
});